let CoinMatchConfig = require("activity/CoinMatchActivity/CoinMatchConfig")
let CoinMatchLogic = require("activity/CoinMatchActivity/CoinMatchLogic")
let CoinMatchManager = require("activity/CoinMatchActivity/CoinMatchManager")
let CoinMatchAttendCalculator = require("activity/CoinMatchActivity/CoinMatchAttendCalculator")
let CoinMatchConst = require("activity/CoinMatchActivity/CoinMatchConst")
let UIProgressTimer = require("clover/panel/component/common/UIProgressTimer")
let SimpleLocker = require("clover/utils/SimpleLocker")

let CoinMatchPanel = xClass("CoinMatchPanel", BasePanel, () => {
    return cc.CSLoader.createNode(CoinMatchConfig.main.csb);
})

CoinMatchPanel.preloadResPromise = function(withMask = false) {
    if (CoinMatchConfig.main.resList.length > 0) {
        return preloadWithLoadingPromise(CoinMatchConfig.main.resList, withMask);
    } else {
        return Promise.resolve();
    }
}

CoinMatchPanel.show = function(lastLvStep, onShowSuccess, onShowFail, onPanelClose) {
    CoinMatchPanel.preloadResPromise()
        .then(()=> {
            let panel = CoinMatchPanel.create(lastLvStep);
            panel.popup(true);
            if(onPanelClose != null)
                panel.on(BasePanelEvent.Close, onPanelClose);
            
            if (onShowSuccess != null)  
                onShowSuccess();
        })
        .catch((err)=> {
            console.error("CoinMatchPanel show failed.", err);
            LogToLogCenter(err);
            if (onShowFail != null) {
                onShowFail(err);
            }
        });
}

CoinMatchPanel.prototype.ctor = function(lastLvStep) {
    BasePanel.prototype.ctor.call(this);
    
    this.stashLvStep = lastLvStep;
    this.initUI();
}

CoinMatchPanel.prototype.initUI = function () {
    let activityTime = GetChildByPath(this, CoinMatchConfig.main.period);
    activityTime.setString(CoinMatchConfig.strings.period);

    this.quesBtn = GetChildByPath(this, CoinMatchConfig.main.btnPrompt);
    quickBuildBtn(this.quesBtn, UIButton, null, ()=> this.onQuesClick());

    this.startBtn = GetChildByPath(this, CoinMatchConfig.main.btnStart);
    quickBuildUIGLabelButton(this.startBtn, ()=> this.onStartClick());

    this.closeBtn = GetChildByPath(this, CoinMatchConfig.main.btnClose);
    quickBuildBtn(this.closeBtn, UIButton, null, handler(this, this.onClose));

    this.getMoreTimeBtn = GetChildByPath(this, CoinMatchConfig.main.btnMore); 
    quickBuildUIGLabelButton(this.getMoreTimeBtn, ()=> this.onClickGetMoreTime());   
    // 抖音不能分享的时候直接广告加步数
    if (window.mini && mini.getPlatform() == MiniPlatform.tt){
        this.ttCanShare = SnsProxy.getInstance().curVerCanShare();
        if (!this.ttCanShare){
            this.updateAdBtn();
            this.getMoreTimeBtn.getChildByName("label").setNextFontPositionXOffset(-4);
            this.getMoreTimeBtn.ttAddBtnFlag(1, cc.p(2, -5))
        } 
    }

    this.showOffBtn = GetChildByPath(this, CoinMatchConfig.main.btnShowOff); 
    this.showOffBtn.setVisible(false);
    quickBuildUIGLabelButton(this.showOffBtn, ()=> this.onShareMessage());

    this.passIcon = GetChildByPath(this, CoinMatchConfig.main.allPass); 
    this.passAllLevelLabel = GetChildByPath(this, CoinMatchConfig.main.allPassWord);
    this.passAllLevelLabel.setString(CoinMatchConfig.strings.rewardPeriod);

    this.resetLabel = GetChildByPath(this, CoinMatchConfig.main.btnReset);
    quickBuildBtn(this.resetLabel, UIButton, PushBounceAnim, ()=> this.onResetClick(), true);

    this.levelLabel = GetChildByPath(this, CoinMatchConfig.main.level);
    if (CoinMatchConfig.main.levelBold)
        this.levelLabel.getVirtualRenderer()._setFontWeight('bold');
    this.leftStepLabel = GetChildByPath(this, CoinMatchConfig.main.leftNum);
}

CoinMatchPanel.prototype.onQuesClick = function() {
    if (this.locker.isLock())
        return;
    
    let isBusy = CoinMatchLogic.showQuesPanel(()=> this.locker.unlock());
    if (!isBusy) 
        this.locker.lock();
}

CoinMatchPanel.prototype.onShareMessage = function() {
    let isBusy = CoinMatchLogic.showOff();
}
CoinMatchPanel.prototype.onStartClick = function () {
    if (this.locker.isLock())
        return;
    CfgManager.load("coin_match")
    .then(() => {
        let config = CfgManager.get("coin_match");
        if (Localhost.timeInSec() <= config.end_time){
            CoinMatchLogic.playLevel(null, null, (callback)=> {
                this.onClose(callback, null, true);
                DCAssist.dc4User101("battleForGold", "click_challenge_btn");
            });
        }else{
            Toast.make(getText("coin.match.overdue"));
        }
    })
}
CoinMatchPanel.prototype.onClickGetMoreTime = function() {
    let self = this;
    CfgManager.load("coin_match")
    .then(() => {
        let config = CfgManager.get("coin_match");
        if (Localhost.timeInSec() <= config.end_time){
            let manager = CoinMatchManager.getInstance();
            manager.setHasOpenMoreStepPanel(true);
            self.getMoreTimeBtn.clearPrompt();
            DCAssist.dc4User101("battleForGold", "click_getMoves_btn");
            self.showGetMoreStepPanel();
        }else{
            Toast.make(getText("coin.match.overdue"));
        }
    })
}    

CoinMatchPanel.prototype.updateAdBtn = function() {
    let adStep = CoinMatchManager.getInstance().getMoreStepsNum();
    if (adStep >= CoinMatchConfig.values.adLimit){
        this.getMoreTimeBtn.setEnabled(false);
        var flag = this.getMoreTimeBtn.getChildByName("ttflag");
        if (flag){
            var p = flag.getPosition();
            flag.setPosition(cc.pAdd(p, cc.p(3, -3)));
        }
    }else{    
        this.getMoreTimeBtn.setEnabled(true);
    }
}

CoinMatchPanel.prototype.showGetMoreStepPanel = function() {    
    if (this.locker.isLock())
        return;

    // 抖音不能分享的时候直接广告加步数
    if (window.mini && mini.getPlatform() == MiniPlatform.tt){
        if (!this.ttCanShare){
            DCAssist.dc4AdClick("battleForGold", "ad_add_step_btn_click");
            CoinMatchLogic.adForMoreStep(
                CoinMatchConst.AdType.kMoreStep,
                ()=> {
                    this.updateAdBtn();
                    this.leftStepLabel.setString(CoinMatchManager.getInstance().getLeftStep());
                });
            return
        }
    }
    let isBusy = CoinMatchLogic.showGetMoreStepPanel(null, 
        ()=> this.locker.unlock(),
        ()=> {
            if (!this.isClosed) {
                this.locker.unlock();
                this.leftStepLabel.setString(CoinMatchManager.getInstance().getLeftStep());
            }
        });

    if (!isBusy) 
        this.locker.lock();
}

CoinMatchPanel.prototype.onEnter = function () {
    BasePanel.prototype.onEnter.call(this);

    if (this.locker == null) {
        this.locker = new SimpleLocker();
        AlignTextBMFont(this, CoinMatchConfig.main.textBMFonts);
    } else 
        this.locker.reset();
        
    let manager = CoinMatchManager.getInstance();
    let passedStep = manager.getPassedLevelStep();
    let lvChanged = this.stashLvStep != null && this.stashLvStep < passedStep;
    this.stashLvStep = passedStep;

    if (this.boxBar != null)
        this.boxBar.restore();

    this.updateUI(lvChanged);

    if (this.canShowMoreStepPrompt())
        this.getMoreTimeBtn.showPrompt();
    else
        this.getMoreTimeBtn.clearPrompt();

    if (this.boxBar == null)
        this.boxBar = new RewardProgress(this, lvChanged);

    if (this.counter == null)
        this.counter = new CoinMatchCounter(this);
    else
        this.counter.resume();
        
    this.resetHandler = CoinMatchManager.getInstance().on(CoinMatchManager.EventEnum.kReset, ()=> this.onReset())[1];
    this.stepChangedHandler = CoinMatchManager.getInstance().on(CoinMatchManager.EventEnum.kStepChanged, ()=> this.onStepChanged())[1];    

    let shareData = CoinMatchLogic.popShareData();
    if(shareData != null)
        CoinMatchLogic.processShareData(shareData);

    CoinMatchManager.getInstance().setShowMainToday();
}

CoinMatchPanel.prototype.onReset = function() {
    this.updateUI(false);
}

CoinMatchPanel.prototype.onStepChanged = function() {
    this.leftStepLabel.setString(CoinMatchManager.getInstance().getLeftStep());
}

CoinMatchPanel.prototype.updateUI = function (lvChanged) {
    let manager = CoinMatchManager.getInstance();
    let passedStep = manager.getPassedLevelStep();
    
    this.onStepChanged();
    
    let lastShowOff = this.showOffBtn && this.showOffBtn.isVisible();
    this.resetLabel.setVisible(CoinMatchLogic.canReset());
     if (manager.hasFinishAllLevel()) {
        this.showOffBtn.setVisible(true);
        this.passAllLevelLabel.setVisible(true);
        this.passIcon.setVisible(true);
        this.startBtn.setVisible(false);
        this.getMoreTimeBtn.setVisible(false);
        this.levelLabel.setString(CoinMatchConfig.strings.passAll);
        this.resetLabel.setVisible(false);
    } else {
        this.showOffBtn.setVisible(false);
        this.passAllLevelLabel.setVisible(false);
        this.passIcon.setVisible(false);
        this.startBtn.setVisible(true);
        this.getMoreTimeBtn.setVisible(true);
        this.getMoreTimeBtn.setVisible(true);
        this.levelLabel.setString(CoinMatchConfig.getLevelStr(manager.getCurrentLevelStep()));
        if (passedStep > 0) {
            this.startBtn.setString(CoinMatchConfig.strings.enter);
        } else {
            this.startBtn.setString(CoinMatchConfig.strings.enterImm);
        }
    }

    if (this.boxBar != null)
        this.boxBar.update(lvChanged);

    if (this.showOffBtn && this.showOffBtn.isVisible() && !lastShowOff) {
        DCAssist.dc4ShareShow("CoinMatchShowOff");
    }
}

CoinMatchPanel.prototype.onResetClick = function() {
    CfgManager.load("coin_match")
    .then(() => {
        let config = CfgManager.get("coin_match");
        if (Localhost.timeInSec() <= config.end_time){
            CoinMatchLogic.showResetPanel();
            DCAssist.dc4User101("battleForGold", "click_reset_btn")
        }else{
            Toast.make(getText("coin.match.overdue"));
        }
    })
}

CoinMatchPanel.prototype.onExit = function() {
    this.removeHandlers();
    if (this.counter != null)
        this.counter.pause();

    BasePanel.prototype.onExit.call(this);
}

CoinMatchPanel.prototype.removeHandlers = function () {
    if (this.resetHandler != null) {
        CoinMatchManager.getInstance().removeEventListener(this.resetHandler);
        this.resetHandler = null;
    }
    if (this.stepChangedHandler != null) {
        CoinMatchManager.getInstance().removeEventListener(this.stepChangedHandler);
        this.stepChangedHandler = null;
    }
}

CoinMatchPanel.prototype.onCleanup = function () {
    this.removeHandlers();

    if (this.counter != null) {
        this.counter.destroy();
        this.counter = null;
    }
    
    if (this.boxBar != null) {
        this.boxBar.destroy();
        this.boxBar = null;
    }

    if (CoinMatchConfig.main.resList.length > 0)
        ResManager.release(CoinMatchConfig.main.resList);
}

CoinMatchPanel.prototype.canShowMoreStepPrompt = function() {
    let manager = CoinMatchManager.getInstance();
    // if (manager.hasShowMainToday()) {
    //     return manager.canGetInviteReward();
    // } else {
    //     return manager.getMoreStepsNum() < CoinMatchConfig.values.adLimit;
    // } 
    if (manager.getHasOpenMoreStepPanel()){
        return false;
    }  else {
        return manager.getMoreStepsNum() < CoinMatchConfig.values.adLimit;
    }
}

class CoinMatchCounter {
    constructor(main) {
        let layout = CoinMatchConfig.main.part;

        let labels = [];
        layout.lbs.forEach((item)=> {
            let lb = GetChildByPath(main, item.path);
            if (item.hasOwnProperty("key")) {
                lb.setString(getText(item.key));
                lb.setContentSize(CalculateLbTTFSize(lb));
            }
            else if (item.hasOwnProperty("strings")) {
                lb.setString(CoinMatchConfig.strings[item.strings]);
                lb.setContentSize(CalculateLbTTFSize(lb));
            }
            else 
                this.countLb = lb;

            
            labels.push(lb);  
        });

        this.labels = labels;
        this.groupCenter = layout.center;

        this.calculator = CoinMatchAttendCalculator.create(CoinMatchConfig.values.startTime, CoinMatchConfig.values.attendHoursCounts);

        this.updateValue(true);
        cc.Director.getInstance().getScheduler().scheduleUpdate(this);
    }

    update() {
        this.updateValue(false);
    }

    updateValue(force) {
        let value = this.calculator.getCurValue();
        if (force || value != +this.countLb.getString()) {
            let oldStr = this.countLb.getString();
            this.countLb.setString(value);           
            if (oldStr.length != value.toString().length) {
                this.countLb.setContentSize(CalculateLbTTFSize(this.countLb));
                HorizontalNodeGroup(this.labels, this.groupCenter);
            }
        }
    }

    pause() {
        cc.Director.getInstance().getScheduler().unscheduleUpdate(this);
    }

    resume() {
        let scheduler = cc.Director.getInstance().getScheduler();
        scheduler.unscheduleUpdate(this);
        scheduler.scheduleUpdate(this);
    }

    destroy() {
        cc.Director.getInstance().getScheduler().unscheduleUpdate(this);
    }
}

class RewardProgress extends cc.Node {
    constructor(main, levelChanged) {
        super();

        let layout = CoinMatchConfig.main.box;
        let lvWeight = CoinMatchConfig.values.lvWeight;
        let manager = CoinMatchManager.getInstance();

        let wholeWeight = 0;
        lvWeight.forEach((w)=> wholeWeight += w);
        this.percentAry = [0];
        let tempPercent = 0;
        lvWeight.forEach((w)=> { 
            tempPercent += w;
            this.percentAry.push(tempPercent / wholeWeight);
        });

        let boxRewards = manager.getBoxRewards();   
        this.boxList = [];

        let posY = layout.y;        
        let xStart = layout.boxStart;
        let boxWidth = layout.boxWidth;        
        let gap = boxWidth / (boxRewards.length + 1);
        for (let i = 0; i < boxRewards.length; i++) {
            let box = new BoxRewardItem(main, xStart + gap * (i + 1), posY, boxRewards[i]);
            this.boxList.push(box);
        }

        this.progressTimer = UIProgressTimer.create(GetChildByPath(main, layout.progress));
        this.progressTimer.setContentOffset(layout.progressOffset.x, layout.progressOffset.y);

        this.update(levelChanged);
    }

    restore() {
        this.boxList.forEach((box)=>box.restore());
    }

    update(levelChanged) {  
        let manager = CoinMatchManager.getInstance();
        let passedLevel =  manager.getPassedLevelStep()

        let activeBox = this.updateBox(passedLevel, levelChanged);
        this.progressTimer.setProgress(this.percentAry[passedLevel]);
        if (activeBox != null) {
            activeBox.playReward(()=> {
                let rewards = table([0, activeBox.data])
                let CommonRewardPanel = require("clover/panel/CommonRewardPanel")[0];
                CommonRewardPanel.show(null, null, rewards);
            });
        } 
    }

    updateBox(passedLevel, levelChanged) {
        let activeBox = null;
        this.boxList.forEach((box)=> {
            if (box.update(passedLevel, levelChanged))
                activeBox = box;
        });
        return activeBox;
    }

    destroy() {
        this.activeBox = null;
        this.progressTimer = null;
        if (this.boxList != null) {
            for(let i = 0; i < this.boxList.length; i++)
                this.boxList[i].destroy();
            this.boxList = null;
        }
        this.boxList = null;
    }
}

class BoxRewardItem {
    constructor(parent, x, y, item) {
        let layout = CoinMatchConfig.main.box;

        this.data = item;

        this.box = QuickCreateAnimNode(layout.boxCsb);
        this.box.setPosition(x, y);
        parent.addChild(this.box);

        this.bubble = cc.CSLoader.createNode(layout.bubbleCsb); 
        this.bubble.setPosition(x + layout.bubbleOffsetX, y + layout.bubbleOffsetY);       
        parent.addChild(this.bubble); 
        this.bubbleBody = GetChildByPath(this.bubble, layout.bubbleBody);
        this.bubbleTail = GetChildByPath(this.bubble, layout.bubbleTail);        
        this.lbLv = GetChildByPath(this.bubble, layout.lv);   
        this.lbLv.setString(CoinMatchConfig.getBoxLevelStr(this.data.lvStep));     
        this.lbNum =  GetChildByPath(this.bubble, layout.num);

        // ActionTimeline在gotoFrameAndPlay运行后才会计算endFrame的值
        this.box.actionTimeLine.gotoFrameAndPlay(0);
        this.box.actionTimeLine.gotoFrameAndPause(0);

        this.icon = null;
    }

    update(passedLevel, needPlayGain) {  
        let layout = CoinMatchConfig.main.box;
        
        let isActive = passedLevel == this.data.lvStep && needPlayGain;
        let gain = this.data.lvStep <= passedLevel && !isActive;

        let bubbleShow = !gain && !isActive;
        
        this.bubbleBody.setVisible(bubbleShow);
        this.bubbleTail.setVisible(bubbleShow);
        this.lbNum.setVisible(bubbleShow);
        
        if (bubbleShow) {
            if (this.icon == null) {
                this.icon = UIItemBuilder.createPropIcon(this.data.itemId);
                this.icon.setPosition(layout.iconPos.x, layout.iconPos.y);
                this.icon.setScale(layout.iconScale);
                this.bubbleBody.addChild(this.icon);

                this.lbNum.setString("x" + this.data.num);
            }
        } else if (this.icon != null)
            this.icon.setVisible(false); 

        this.box.actionTimeLine.gotoFrameAndPause(gain? this.box.actionTimeLine.getEndFrame(): 0);

        return isActive;
    }

    restore() {        
        this.box.runAction(this.box.actionTimeLine);
    }

    playReward(onOpenStart) {
        let boxAnim = this.box.actionTimeLine;
        
        if (boxAnim.isPlaying()) {
            boxAnim.setLastFrameCallFunc(()=> {
                boxAnim.play("open", false);
                boxAnim.setLastFrameCallFunc(()=> {
                    boxAnim.clearLastFrameCallFunc();
                    onOpenStart();
                });
            });
        } else {
            boxAnim.play("open", false);
            boxAnim.setLastFrameCallFunc(()=> {
                boxAnim.clearLastFrameCallFunc();
                onOpenStart();
            });
        }
    }   

    destroy() {
        this.data = null;

        this.box = null;

        this.bubble = null;
        this.bubbleBody = null;
        this.bubbleTail = null;        
        this.lbLv = null;   
        this.lbNum =  null;

        this.icon = null;
    }
}

module.exports = CoinMatchPanel